<div class="row">
    <p class="col-lg-11 col-md-11"><b>There is no previous consultation associated with this patient to set Follow Up date. Please start consultation and set follow up date.</b></p>
    <img class="col-lg-1 col-md-1 img" (click)="close()" src="assets/cancel.svg">
</div>
